import type { BlogPostListParams } from '../api/blog-api';

/** Store-scoped keys: switching stores never shares cache. */
export const blogKeys = {
  all: (storeId: string) => ['stores', storeId, 'blog'] as const,
  posts: (storeId: string) => [...blogKeys.all(storeId), 'posts'] as const,
  postLists: (storeId: string) => [...blogKeys.posts(storeId), 'list'] as const,
  postList: (storeId: string, params: BlogPostListParams) =>
    [...blogKeys.postLists(storeId), params] as const,
  postDetails: (storeId: string) => [...blogKeys.posts(storeId), 'detail'] as const,
  postDetail: (storeId: string, id: string) => [...blogKeys.postDetails(storeId), id] as const,
  categories: (storeId: string) => [...blogKeys.all(storeId), 'categories'] as const,
};
